import { render, staticRenderFns } from "./FpsClock.vue?vue&type=template&id=f72deafa&scoped=true&"
import script from "./FpsClock.vue?vue&type=script&lang=js&"
export * from "./FpsClock.vue?vue&type=script&lang=js&"
import style0 from "./FpsClock.vue?vue&type=style&index=0&id=f72deafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72deafa",
  null
  
)

export default component.exports